import LTR from "@brand-icons/ploom/ui-minus/ui-minus-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiMinusIcon = iconFactory("UiMinusIcon", LTR);
